export const environment = {
  production: true,
  buildId: '3677200226423131',
  configFile: 'config.json',
};
